export default __webpack_public_path__ + "static/media/robot-icon.dd76803a.webp";